module.exports = __webpack_public_path__ + "img/More.c9ed4360.png";